import { useEffect, useState } from "react";
import { useAuthContext } from "./useAuthContext";
// firebase imports
import { auth, db, parseError } from "../firebase/config";
import { signOut } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";

export const useLogout = () => {
    const [isCancelled, setIsCancelled] = useState(false);
    const [error, setError] = useState(null);
    const [isPending, setIsPending] = useState(false);
    const { dispatch, user } = useAuthContext();

    const logout = async () => {
        setError(null);
        setIsPending(true);

        // sign the user out
        try {
            // set online status for current user
            const { uid } = user;

            await updateDoc(doc(db, "users", uid), { online: false });

            // signout
            await signOut(auth);

            // dispatch logout action
            dispatch({ type: "LOGOUT" });

            // update state
            if (!isCancelled) {
                setIsPending(false);
                setError(null);
            }
        } catch (err) {
            if (!isCancelled) {
                setError(parseError(err.code));
                console.log(err);
                setIsPending(false);
            }
        }
    };

    useEffect(() => {
        return () => setIsCancelled(true);
    }, []);

    return { logout, error, isPending };
};
